import { keepPreviousData, queryOptions } from "@tanstack/react-query"

import { getIsomorphicSupabaseClient } from "@repo/supabase/isomorphic-client"
import type { DataTableBaseSearch } from "~/lib/schemas/common"
import { createClientsService } from "./clients.service"

export const getExtendedClientsQueryOptions = ({
  filters,
}: {
  filters?: DataTableBaseSearch
} = {}) =>
  queryOptions({
    queryKey: filters ? ["extended-clients", filters] : ["extended-clients"],
    queryFn: async () => {
      const supabase = await getIsomorphicSupabaseClient()
      const clientsService = createClientsService(supabase)
      return clientsService.getManyExtended(filters)
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    placeholderData: keepPreviousData,
  })

export const getExtendedClientQueryOptions = ({
  clientSlug,
}: {
  clientSlug: string
}) =>
  queryOptions({
    queryKey: ["extended-client", clientSlug],
    queryFn: async () => {
      const supabase = await getIsomorphicSupabaseClient()
      const clientsService = createClientsService(supabase)
      return clientsService.getOneExtended(clientSlug)
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })

export const getClientMembersQueryOptions = ({
  clientSlug,
}: {
  clientSlug: string
}) =>
  queryOptions({
    queryKey: ["client-members", clientSlug],
    queryFn: async () => {
      const supabase = await getIsomorphicSupabaseClient()
      const clientsService = createClientsService(supabase)
      return clientsService.getMembers(clientSlug)
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })

export const getClientOverviewStatsQueryOptions = ({
  clientSlug,
}: {
  clientSlug: string
}) =>
  queryOptions({
    queryKey: ["client-overview-stats", clientSlug],
    queryFn: async () => {
      const supabase = await getIsomorphicSupabaseClient()
      const clientsService = createClientsService(supabase)
      return clientsService.getOverviewStats(clientSlug)
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
